const gk_pricingBlock = {
  load() {
    document.querySelectorAll('.PricingBlock').forEach((block) => {
      if (block.dataset.gkInit) return;
      block.dataset.gkInit = '1';

      const toggle = block.querySelector('.PricingBlock-toggleSwitch');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const isB  = toggle.getAttribute('aria-pressed') === 'true';
        const plan = isB ? 'a' : 'b';

        toggle.setAttribute('aria-pressed', String(!isB));
        block.dataset.plan = plan;

        block.querySelectorAll('.PricingBlock-price').forEach((priceEl) => {
          const amount = priceEl.querySelector('.PricingBlock-priceAmount');
          const target = priceEl.dataset[`price${plan.toUpperCase()}`];

          priceEl.classList.add('-switching');
          setTimeout(() => {
            amount.textContent = target;
            priceEl.classList.remove('-switching');
          }, 200);
        });
      });
    });
  },
};

export default gk_pricingBlock;
